import { useEffect } from "react";
import { PieChart } from "../../components/Charts/PieChart"
import { useRecurrencia } from "../../hooks/useRecurrencia";
import dayjs from "dayjs";
import "dayjs/locale/es";
import "./recurrencia.css";
dayjs.locale('es');

export const Recurrencia = () => {
    const { getAniosRecurrencia, years, selectYear, handleChangeSelect, recurrenciaData, getDescripcionRecurrencia, descripcion, chartColors } = useRecurrencia();
    useEffect(() => {
        getAniosRecurrencia();
        getDescripcionRecurrencia();
    }, []);
    
    const today = dayjs(new Date).format('MMMM D, YYYY');

    return (
        <div className="container">
            <div className="row pt-5" >
                <div className="d-flex justify-content-center">
                   
                <h1 className="recurrencia-title">SOLICITUDES RECURRIDAS EN {selectYear}</h1>
                </div>
                <div className="d-flex justify-content-end">
                <p className="recurrencia-update-date fw-bold">Última actualización: {descripcion.length ? descripcion?.[0].fecha_actualizacion : ""} </p>
                </div>
            </div>
            <p className="mb-4 mt-3 recurrencia-descripcion">{descripcion.length ? descripcion?.[0].descripcion : today}</p>
            <div className="row justify-content-center">
                <select
                    value={selectYear}
                    className="form-control recurrencia-select fw-bold"
                    onChange={handleChangeSelect}>
                    {years?.map((year) => (
                        <option key={year.value} className="text-dark fw-bold" value={year.value}>{year.label}</option>
                    ))}
                </select>
            </div>

            <div className="row">
                <PieChart data={recurrenciaData} colors={chartColors} />
            </div>
        </div>
    )
}
